export interface OutOfPeriodAdjustment {
    id:string;
    period:string;
    year:string;
    amount:number;
    reason:string;
    createdBy?:string;
    createdDate?:Date;
    isApproved?:boolean;
    approvedBy?:string;
    approvedDate?:Date;
    isVoided?:boolean;
    voidedBy?:string;
    voidedDate?:Date;

}

export function DefaultOutOfPeriodAdjustment():OutOfPeriodAdjustment{
    return {id:'', period:'', year:'', amount:0, reason:''}
}

// Types for OPA Upload workflow
export type UploadRowStatus = 'pending' | 'validating' | 'valid' | 'valid-warning' | 'invalid' | 'uploading' | 'uploaded' | 'failed';

export interface OutOfPeriodAdjustmentRow {
    accountNumber: string;
    period: string;
    year: string;
    amount: string;
    reason: string;
}

export interface UploadRowState {
    lineNumber: number;
    data: OutOfPeriodAdjustmentRow;
    status: UploadRowStatus;
    errorMessage?: string;
    warningMessage?: string;
}

export interface ValidateRowRequest {
    centerId: string;
    row: OutOfPeriodAdjustmentRow;
    lineNumber: number;
}

export interface ValidateRowResponse {
    lineNumber: number;
    isValid: boolean;
    errorMessage?: string;
    hasWarning?: boolean;
    warningMessage?: string;
}

export interface UploadRowRequest {
    centerId: string;
    row: OutOfPeriodAdjustmentRow;
    lineNumber: number;
}

export interface UploadRowResponse {
    lineNumber: number;
    success: boolean;
    adjustmentId?: string;
    errorMessage?: string;
}